import { ChartDataResponse }                                   from '@/components/chart/chart.types';
import { DataZoomAxis, ScrollStartPosition }                   from '@/components/chart/helpers/chart-variables';
import { ObjectWithStringKeys }                                from '@/types';
import { FilterPanelState, LeadFilterDetails, SelectedFilter } from '@/components/filter-panel/filter-panel.types';

export interface ScrollPosition<T> {
  axis?: T;
  start: number;
  end: number;
}

export interface DataZoom {
  xAxis: ScrollPosition<DataZoomAxis.X_AXIS>;
  yAxis: ScrollPosition<DataZoomAxis.Y_AXIS>;
}

export interface DataZoomSliderEvent {
  dataZoomId: string;
  start: number;
  end: number;
  from: string;
  type: string;
}

export interface DataZoomInsideEvent extends DataZoomSliderEvent {
  batch: DataZoomSliderEvent[];
  escapeConnect: undefined;
}

export interface ChangeLegendEvent {
  name: string;
  selected: ObjectWithStringKeys<boolean>;
  type: string;
}

export interface FilterConfigurationJSON {
  selectedFilters: SelectedFilter[];
  selectedFunctions: string[];
  appliedTabs: string[];
  trackedTabs: string[];
  leadFilter: LeadFilterDetails;
}

export interface FilterConfiguration {
  name: string;
  json: FilterConfigurationJSON | string | null;
}

export interface State {
  chartData: {
    chartUuid: string;
    chartDataCollection: ChartDataResponse[];
    isLoading: boolean;
  };
  isScrollRight: boolean;
  initialIsScrollRight: boolean;
  isLogarithmicAxis: boolean;
  initialIsLogarithmicAxis: boolean;
  isTableView: boolean;
  initialIsTableView: boolean;
  dataZoom: DataZoom;
  legendSeries: ObjectWithStringKeys<boolean>;
  filterConfigurations: FilterConfiguration[];
  filterActiveConfiguration: string;
  filterPanel?: FilterPanelState;
  chartHeight: number | null;
}

export default function state(): State {
  return {
    chartData: {
      chartUuid: '',
      chartDataCollection: [],
      isLoading: true,
    },
    initialIsScrollRight: false,
    isScrollRight: false,
    isLogarithmicAxis: false,
    initialIsLogarithmicAxis: false,
    isTableView: false,
    initialIsTableView: false,
    dataZoom: {
      xAxis: {
        start: ScrollStartPosition.start,
        end: ScrollStartPosition.end,
      },
      yAxis: {
        start: ScrollStartPosition.start,
        end: ScrollStartPosition.end,
      },
    },
    legendSeries: {},
    filterConfigurations: [],
    filterActiveConfiguration: '',
    chartHeight: null,
  };
}
